import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface CounterDotsCstProps {
  counters: string[];
}

const CounterDotsCst: React.FC<CounterDotsCstProps> = ({ counters }) => {
  const theme = useTheme();

  if (counters.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {counters.map((label) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: theme.palette.primary.main,
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: theme.palette.text.primary,
            }}
          >
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CounterDotsCst;
